import { FieldDefinition, FieldBuilder, REASON_GROUP_NAME_NEGOTIATION_STATE, REASON_GROUP_NAME_STAND_STATE } from '@zendra/shared';
import { ReasonService } from 'cbd-proxies';
import { PipelinePropertyService } from '../proxy/operational/controllers';

FieldBuilder.setNamespace('Operational');

export const PIPELINESTAND_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .text('name', 'Entity.PipelineStand.Name')
    .required()
    .maxLength(100)
    .build(),
  FieldBuilder
    .number('area', 'Entity.PipelineStand.Area')
    .required()
    .decimal()
    .build(),
  FieldBuilder
    .text('coneatSoil', 'Entity.PipelineStand.ConeatSoil')
    .readOnly()
    .build(),
  FieldBuilder.foreignKey(
    'pipelinePropertyId',
    'Entity.PipelineStand.PipelineProperty',
    PipelinePropertyService
  )
    .required()
    .display('name')
    .displayFromNested('pipelinePropertyName')
    .sortBy('pipelinePropertyName')
    .keyField('id')
    .hideInChildForms()
    .build(),
  FieldBuilder.foreignKey(
    'standReasonId',
    'Entity.PipelineStand.StandReason',
    ReasonService
  )
    .required()
    .queryFilter({ reasonGroupName: REASON_GROUP_NAME_STAND_STATE })
    .display('name')
    .displayFromNested('standReasonName')
    .sortBy('standReasonName')
    .keyField('id')
    .build(),
  FieldBuilder.foreignKey(
    'negotiationReasonId',
    'Entity.PipelineStand.NegotiationReason',
    ReasonService
  )
    .required()
    .queryFilter({ reasonGroupName: REASON_GROUP_NAME_NEGOTIATION_STATE })
    .display('name')
    .displayFromNested('negotiationReasonName')
    .sortBy('negotiationReasonName')
    .keyField('id')
    .build(),
];

export const PIPELINESTAND_CONFIG = {
  entityName: 'PipelineStand',
  localizationKey: 'Operational::Entity.PipelineStand',
  fields: PIPELINESTAND_FIELDS,
  permission: 'PlanningOperation.PipelineStands',
  showInMenu: false,
  menuCategory: '',
  menuSubcategory: '',
};
